import { AiToolImpl } from "@me8eon/aiclient";
import { JwtTokenFn, tokenToUserData } from "@me8eon/authentication";
import { checkIfWindows } from "@me8eon/browser";
import { getWorkingStorage } from "@me8eon/react_storage";
import { TeamsActionWidgetMeta } from "me-at-eon/src/modules/AiWidgets/nexthink/TeamsAction.widget";

type ToolArgs = Record<string, never>;
type ToolImpl = AiToolImpl<ToolArgs>;
type Tool = (trueDemApiTokenFn: JwtTokenFn, jwtTokenFn: JwtTokenFn) => ToolImpl;

export const DisplayTeamsActionToolImpl: Tool = (trueDemApiTokenFn: JwtTokenFn, jwtTokenFn: JwtTokenFn) => {
    return {
        type: "service_api",
        toolDefn: {
            type: "function",
            name: "display_teams_action",
            description:
                "This tool displays a Teams action widget. Here user can interact with Teams actions.",
            parameters: {
                type: "object",
                properties: {},
                required: [],
                additionalProperties: false,
            }
        },
        execute: async (_options, _args) => {
            const token = await jwtTokenFn();
            const { company } = await tokenToUserData(token, getWorkingStorage());
            if (company !== "E.ON Digital Technology GmbH" || !checkIfWindows()) {
                return {
                    value: "No widget action found, show the response from semanticHybridSearch tool"
                }
            }

            const widgetMeta: TeamsActionWidgetMeta = {
                name: "teams_widget",
                title: "Teams Action",
                description: "Displays a widget to interact with Teams actions",
                type: "widget",
                componentName: "TeamsActionWidget",
                props: {
                    trueDemApiTokenFn
                },
                displaySettings: {
                    mode: "inThisSessionOnly",
                    sessionId: "somesessionid"
                }
            };

            return {
                _meta: {
                    widget: widgetMeta,
                    skipAiSummary: true
                },
                value: "Displaying Teams Action Widget"
            };
        }
    };
};